import { ChakraProvider, ColorModeScript, theme } from '@chakra-ui/react';
import { useAutoTheme, useElectron } from 'app/utils/hooks';
import { Alerts } from 'app/components/Alerts';
import { darkTheme, lightTheme } from 'app/chakra-theme';
import { Outlet } from 'react-router-dom';
import { useRef } from 'react';
import { ThemeMode } from 'types/enums';
import { AppScrollPortalContext } from './components/AppScrollPortalContext';
import { OUTSIDE_SCROLL_ELEMENT_ID } from './constants';
import { useAppSelector } from './store';
import { getThemePaletteTypeSelector } from './store/Settings/selectors';

export const Root = () => {
  useElectron();
  useAutoTheme();
  const paletteType = useAppSelector(getThemePaletteTypeSelector);

  const outsideScrollContainer = useRef<HTMLDivElement>(null);
  return (
    <AppScrollPortalContext.Provider value={outsideScrollContainer}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ChakraProvider
        theme={paletteType === ThemeMode.LIGHT ? lightTheme : darkTheme}
        toastOptions={{
          portalProps: {
            containerRef: outsideScrollContainer,
          },
        }}
      >
        <Alerts />
        <Outlet />
        <div ref={outsideScrollContainer} id={OUTSIDE_SCROLL_ELEMENT_ID} />
      </ChakraProvider>
    </AppScrollPortalContext.Provider>
  );
};
